import listActions from 'src/modules/soundTitle/list/soundTitleListActions';
import SoundTitleService from 'src/modules/soundTitle/SoundTitleService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'SOUNDTITLE_DESTROY';

const soundTitleDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: soundTitleDestroyActions.DESTROY_STARTED,
      });

      await SoundTitleService.destroyAll([id]);

      dispatch({
        type: soundTitleDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.soundTitle.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/sound-title');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: soundTitleDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: soundTitleDestroyActions.DESTROY_ALL_STARTED,
      });

      await SoundTitleService.destroyAll(ids);

      dispatch({
        type: soundTitleDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.soundTitle.destroyAll.success'),
      );

      getHistory().push('/sound-title');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: soundTitleDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default soundTitleDestroyActions;
